import { render, staticRenderFns } from "./SRPUBelievers.vue?vue&type=template&id=5cd3ea1a&scoped=true"
import script from "./SRPUBelievers.vue?vue&type=script&lang=js"
export * from "./SRPUBelievers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd3ea1a",
  null
  
)

export default component.exports